import { Switch } from '@material-ui/core'
import { useUser } from 'components/providers/UserProvider'
import { editUserAttribute } from 'lib/api'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const OrdersSettingsPresenter = (): JSX.Element => {
  const { t } = useTranslation()
  const { user, setUser } = useUser()
  const { enqueueSnackbar } = useSnackbar()
  const activatedSmartLocation = !!user.activeSmartLocations
  const [showEmptyPickingLocations, setShowEmptyPickingLocations] = useState(
    user.showEmptyPickingLocations ?? false
  )
  const [showAvailableQuantity, setShowAvailableQuantity] = useState(
    user.showAvailableQuantityInPickingLocations ?? false
  )

  const handleChangeSmartLocation = async () => {
    try {
      const response = await editUserAttribute(!activatedSmartLocation, 'activeSmartLocations')
      setUser({ ...user, ...response })
    } catch (e) {
      enqueueSnackbar(t('orders.picking.smartLocationsSaveError'), { variant: 'error' })
    }
  }

  const handleChangeShowEmptyPickingLocations = async () => {
    const next = !showEmptyPickingLocations
    try {
      const response = await editUserAttribute(next, 'showEmptyPickingLocations')
      setUser({ ...user, ...response })
      setShowEmptyPickingLocations(next)
    } catch (e) {
      enqueueSnackbar(t('orders.picking.showEmptyLocationsSaveError'), { variant: 'error' })
    }
  }

  const handleChangeShowAvailableQuantity = async () => {
    const next = !showAvailableQuantity
    try {
      const response = await editUserAttribute(next, 'showAvailableQuantityInPickingLocations')
      setUser({ ...user, ...response })
      setShowAvailableQuantity(next)
    } catch (e) {
      enqueueSnackbar(t('orders.picking.showAvailableQuantitySaveError'), { variant: 'error' })
    }
  }

  return (
    <>
      <div className="d-flex flex-row align-items-center">
        <span>{t('common.smartLocationsLabel')}</span>
        <Switch
          name="smart locations"
          checked={activatedSmartLocation}
          onChange={handleChangeSmartLocation}
        />
      </div>
      <p>{t('orders.picking.smartLocations')}</p>
      <div className="d-flex flex-row align-items-center mt-3">
        <span>{t('common.showEmptyLocationsLabel')}</span>
        <Switch
          name="show empty picking locations"
          checked={showEmptyPickingLocations}
          onChange={handleChangeShowEmptyPickingLocations}
        />
      </div>
      <p>{t('orders.picking.showEmptyLocations')}</p>
      <div className="d-flex flex-row align-items-center mt-3">
        <span>{t('common.showAvailableQuantityLabel')}</span>
        <Switch
          name="show available quantity in picking locations"
          checked={showAvailableQuantity}
          onChange={handleChangeShowAvailableQuantity}
        />
      </div>
      <p>{t('orders.picking.showAvailableQuantity')}</p>
    </>
  )
}
